import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=7a40111e&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=7a40111e&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a40111e"]])

export default __exports__